import { render, staticRenderFns } from "./WishlistItemDropdown.vue?vue&type=template&id=7bb81651"
import script from "./WishlistItemDropdown.vue?vue&type=script&lang=js"
export * from "./WishlistItemDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports